import { pxToRem } from '@fluentsms/agentnet-web-components';
import { CSSProperties } from 'react';

export const UnderlinedCurrencyEditorStyle: CSSProperties = {
  border: 'none',
  borderBottom: '1px solid #1976d2',
  outline: 'none',
  background: 'transparent',
  width: '100%',
  fontSize: pxToRem(14),
  textAlign: 'right',
};

export const CurrencyEditorStyle: CSSProperties = {
  border: 'none',
  outline: 'none',
  background: 'transparent',
  width: '100%',
  fontSize: pxToRem(14),
  textAlign: 'right',
};

export interface CurrencyEditorProps {
  value: string;
  onValueChange: (value: string) => void;
  eGridCell: HTMLElement;
}

export const UnderlinedCurrencyEditor = ({ value, onValueChange, eGridCell }: CurrencyEditorProps): JSX.Element => {
  eGridCell.classList.remove('ag-cell-inline-editing');
  return (
    <input
      autoFocus={true}
      type="text"
      style={UnderlinedCurrencyEditorStyle}
      value={value || ''}
      onChange={({ target: { value } }) => {
        const cleaned = value?.replace(/[^0-9.]/g, '') ?? '';
        onValueChange(cleaned);
      }}
    />
  );
};

export const CurrencyEditor = ({ value, onValueChange, eGridCell }: CurrencyEditorProps): JSX.Element => {
  eGridCell.classList.remove('ag-cell-inline-editing');
  return (
    <input
      autoFocus={true}
      type="text"
      value={value || ''}
      style={CurrencyEditorStyle}
      onChange={({ target: { value } }) => {
        const cleaned = value?.replace(/[^0-9.]/g, '') ?? '';
        onValueChange(cleaned);
      }}
    />
  );
};
